import React, { useEffect, useState } from "react";
import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";
import Header from "../../Components/Header2/Header2";
import "./NeedPermis.css";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../Context/UserContext";


const NeedPermis: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  

  useEffect(() => {
    // Redirect if not admin
    if (user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, [user?.roles, navigate]);

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // Optional: Adds a smooth scrolling animation
  });
  return (
    <div className="generalPage">
      <div className="landingPage">
        <Header />
        <div className="needPermission">
          {isLoggedIn ? (
            <h2>
              You are logged in but you do not have access to this page yet. Please{" "}
              <Link to="../request-info">request</Link> more information.
            </h2>
          ) : (
            <h2>
              You may not have access to this page yet. Please{" "}
              <Link to="../user-login">logIn</Link> or{" "}
              <Link to="../register">create</Link> an account or{" "}
              <Link to="../request-info">request</Link> more information.
            </h2>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NeedPermis;
